

const webcontent = () =>{
    return (
        
                      <div className="container mt-4">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="saptitle erptitle">What Is ERP in Healthcare?</div>
                <p className="erppara"> 
                ERP in healthcare industry integrates various processes into a unified system, optimizing data management, resource allocation, and decision-making. This centralized approach fosters efficient communication and collaboration, with tailored systems addressing specific industry needs and functions to enhance overall organizational efficiency.
                </p>
                <ul className="websub erpul">
	<li className="webpoints">ERP systems centralize electronic health records (EHR), providing doctors and nurses with real-time access to patient histories, lab results, and prescriptions. </li>
    <li className="webpoints">ERP helps in scheduling staff, monitoring workloads, and managing payroll, ensuring optimal utilization of human resources.</li>
                </ul>
                
                    </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <img src="https://techzon.com/images/2021/03/27/0.29771300-1588251728.jpg" alt="erp" className="img-erp img-shadow" />
                </div>
            </div>
        </div>
 
        
    )
}

export default webcontent